import {
  Svg,
  type SvgProps,
} from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import type { FunctionComponent } from 'react';

export const Pin: FunctionComponent<SvgProps> = (props) => (
  <Svg optimizationId="iconsSystemPin" viewBox="0 0 24 24" {...props}>
    <path
      d="M15.975 15.265l3.335-3.333a.64.64 0 00-.036-.94 6.03 6.03 0 00-5.587-1.208l-3.486-2.726a3.512 3.512 0 00-1.013-2.87.64.64 0 00-.906 0L4.188 8.28a.64.64 0 000 .907 3.509 3.509 0 002.87 1.013l2.628 3.362a6.063 6.063 0 001.11 5.906.645.645 0 00.463.223h.025c.17 0 .332-.067.452-.187l3.334-3.334 3.64 3.64a.639.639 0 001.094-.452.64.64 0 00-.188-.454l-3.64-3.64z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </Svg>
);

Pin.displayName = 'Pin';
